(() => {
  const VERSION = '2026.08.25.1';
  if (window.BHCartToast?.version === VERSION) {
    window.BHCartToast.refresh?.();
    return;
  }

  const timers = new WeakMap();

  function clearTimer(toast) {
    const timer = timers.get(toast);
    if (timer) window.clearTimeout(timer);
    timers.delete(toast);
  }

  function closeToast(toast) {
    clearTimer(toast);
    toast.classList.remove('is-counting');
    const host = toast.closest('cart-notification');

    if (host && typeof host.close === 'function') {
      host.close();
      return;
    }

    toast.classList.remove('active', 'animate');
    toast.removeAttribute('open');
  }

  function beginCountdown(toast) {
    if (!toast.classList.contains('active')) return;

    clearTimer(toast);
    toast.classList.remove('is-counting');
    void toast.offsetWidth;
    toast.classList.add('is-counting');

    const host = toast.closest('[data-bh-cart-toast]');
    const duration = Math.max(1000, Number(host?.dataset.duration) || 3000);
    toast.style.setProperty('--bh-toast-duration', `${duration}ms`);
    timers.set(toast, window.setTimeout(() => closeToast(toast), duration));
  }

  function mount(host) {
    if (host.dataset.bhToastMounted === 'true') return;
    const toast = host.querySelector('.bh-cart-toast');
    const closeButton = host.querySelector('.bh-cart-toast__close');
    const product = host.querySelector('#cart-notification-product');
    if (!toast || !closeButton || !product) return;

    host.dataset.bhToastMounted = 'true';
    closeButton.addEventListener('click', () => closeToast(toast));

    let wasActive = toast.classList.contains('active');

    new MutationObserver(records => {
      const isActive = toast.classList.contains('active');
      const justOpened = isActive && !wasActive;
      const justClosed = !isActive && wasActive;
      const productChanged = records.some(record =>
        record.type === 'childList' &&
        (record.target === product || product.contains(record.target))
      );
      wasActive = isActive;

      if (isActive && (justOpened || productChanged)) {
        beginCountdown(toast);
      } else if (justClosed) {
        clearTimer(toast);
        toast.classList.remove('is-counting');
      }
    }).observe(toast, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });

    if (toast.classList.contains('active')) beginCountdown(toast);
  }

  function refresh() {
    document.querySelectorAll('[data-bh-cart-toast]').forEach(mount);
  }

  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node =>
      node instanceof Element && (node.matches?.('[data-bh-cart-toast]') || node.querySelector?.('[data-bh-cart-toast]'))
    ))) refresh();
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.BHCartToast = {
    version: VERSION,
    refresh,
    close() {
      document.querySelectorAll('.bh-cart-toast.active').forEach(closeToast);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
})();
